import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { IEmployee } from '../../shared/classes/IEmployee';
import { LoadingPopupComponent } from '../loading-popup/loading-popup.component';
import { EmployeeService } from '../../shared/services/employee/employee.service';
import { firstValueFrom } from 'rxjs';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.css'],
    standalone: true,
    imports: [FormsModule, MatDialogActions]
})
export class AddUserComponent {
    public newEmployee: IEmployee;
    public gid: string;
    public role: 'Admin' | 'Inspector' | 'None';
    public site: 'Flanders' | 'Swords' | 'Llanberis' | 'Las Angeles' | 'Los Angeles' | 'None';

    /**
     * Constructs a new popup prompting the user to enter a supplier's information.
     */
    constructor(
        private dialogRef: MatDialogRef<AddUserComponent>,
        private loadingDialog: MatDialog,
        private employeeService: EmployeeService
    ) {}

    /**
     * Close the popup and do not add a supplier.
     */
    cancel(): void {
        this.dialogRef.close(true);
    }

    /**
     * Close the popup and indicate the the supplier should be added.
     */
    submit(): void {
        const promise = (async (): Promise<void> => {
            if (!this.site) {
                throw new Error('Please select a site.');
            }
            if (!this.role) {
                throw new Error('Please select a role.');
            }

            this.site = this.site === 'Los Angeles' ? 'Las Angeles' : this.site;
            await firstValueFrom(
                this.employeeService.updateUser({
                    role: this.role,
                    site: this.site,
                    gid: this.gid.toUpperCase()
                })
            );

            this.dialogRef.close(true);
            window.location.reload();
        })();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            promise
        };
        this.loadingDialog.open(LoadingPopupComponent, dialogConfig);
    }
}
